@if (phase$ | async; as phase) {
<div class="sg-pos-abs-blocked sg-justify-center sg-items-center">
  @switch (phase.type) { @case ('run') {
  <mat-spinner></mat-spinner>
  } @case ('resolve') {
  <div class="sg-async-gui-result-container sg-async-gui-resolve sg-bg-color-success">
    <mat-icon>sg_checkmark_circle</mat-icon>
    <span>{{ data.successMessage }}</span>
  </div>
  } @case ('reject') {
  <div class="sg-async-gui-result-container sg-async-gui-reject sg-bg-color-error">
    <mat-icon>sg_cross_circle</mat-icon>
    <span>{{ data.errorMessage }}</span>
  </div>
  } }
</div>
}
